import { render } from "./Index.vue?vue&type=template&id=19f6197e"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "@/static/css/home/index.css?vue&type=style&index=0&lang=css"
import "./Index.vue?vue&type=style&index=1&id=19f6197e&lang=css"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__